import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-left",
  "use": "icon-left-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-left\"><path d=\"M9.737.854L3.69 8l6.047 7.146l1.526-1.292L6.31 8l4.953-5.854z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol